import React from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Form, Select } from 'semantic-ui-react'
import layoutStyles from '../../containers/AppLayout/styles.module.less'
import { getError } from '../../containers/TradeForm/helpers'
import { TradeFormErrors, TradeFormTouched, TradeFormValues } from '../../containers/TradeForm/Types'
import { useAccountSearch } from '../../hooks'
import { AccountDetails, Correspondent } from '../../types'
import { AccountTypeEnum } from '../../types/AccountTypeEnum'
import { RoutesEnum } from '../../types/RoutesEnum'
import { getAppConfigSetting } from '../../utils'
import styles from './AccountInfoBar.module.less'
import InfoDetail from './components/InfoDetail'

export interface AccountInfoBarProps {
  accountDetails: AccountDetails
  correspondent: Correspondent
  errors: TradeFormErrors
  handleBlur: (field: string) => void
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void
  touched: TradeFormTouched
  values: TradeFormValues
}

const AccountInfoBar: React.FunctionComponent<AccountInfoBarProps> = ({
  accountDetails,
  correspondent,
  errors,
  handleBlur,
  setFieldValue,
  touched,
  values: { accountType: accountTypeOverride, repCode },
}: AccountInfoBarProps) => {
  const {
    accountSearchState: {
      accountResults: { length: searchResultsLength },
      searchTerm,
    },
  } = useAccountSearch()
  const allowedAccountTypeOptions = {
    [AccountTypeEnum.Cash]: [AccountTypeEnum.Cash],
    [AccountTypeEnum.Margin]: [AccountTypeEnum.Cash, AccountTypeEnum.Margin, AccountTypeEnum.Short],
    [AccountTypeEnum.Dvp]: [AccountTypeEnum.Dvp],
    [AccountTypeEnum.Short]: [AccountTypeEnum.Short],
  }
  const accountTypeOptions = allowedAccountTypeOptions[accountDetails.accountType || AccountTypeEnum.Cash].map(
    enumVal => ({
      key: enumVal,
      value: enumVal,
      text: enumVal,
    })
  )
  const changeAccountDestination = searchResultsLength > 1 ? `/${RoutesEnum.Results}/${searchTerm}` : '/'
  return (
    <div className={layoutStyles.offsetBar}>
      <Form className={`${styles.accountInfoBar} account-info-bar`}>
        <InfoDetail label={'Title'}>
          <span>{accountDetails.accountTitle}</span>
        </InfoDetail>
        <InfoDetail label={'Account #'}>
          <a
            href={`${getAppConfigSetting('appsUrl')}/accounts/#/${accountDetails.accountNumber}`}
            target={'_blank'}
            rel="noopener noreferrer"
          >
            {accountDetails.accountNumber}
          </a>
        </InfoDetail>
        <InfoDetail label={'Corr Name'}>
          <span>{correspondent.name}</span>
        </InfoDetail>
        <InfoDetail label={'Corr Code'}>
          <span>{correspondent.code}</span>
        </InfoDetail>
        {accountDetails.restrictionCode && (
          <InfoDetail label={'Account Rest.'}>
            <span className={styles.textRed}>{accountDetails.restrictionCode}</span>
          </InfoDetail>
        )}
        <InfoDetail label={'Rep Code *'}>
          <Form.Input
            className={styles.repCode}
            error={getError('repCode', errors, touched)}
            onBlur={() => handleBlur('repCode')}
            onChange={(_, data) => {
              setFieldValue('repCode', data.value)
            }}
            required
            value={repCode}
          />
        </InfoDetail>
        <InfoDetail label={'Account Type *'}>
          <Select
            options={accountTypeOptions}
            value={accountTypeOverride || accountDetails.accountType}
            onChange={(_, data) => {
              setFieldValue('accountType', data.value)
              setFieldValue('action', undefined)
            }}
          />
        </InfoDetail>
      </Form>
      <div className={styles.changeAccountWrap}>
        <Link to={changeAccountDestination} className={styles.changeAccountLink}>
          <FaArrowLeft className={styles.changeAccountArrow} />{' '}
          <span className={styles.changeAccountText}>Change Account</span>
        </Link>
      </div>
    </div>
  )
}

export default AccountInfoBar
